import Config from '../launch/config'
import Effects from '../effects/effects'
import {_addToEventLog, forceAppUpdate} from '../app/app'
import {saveGame} from '../launch/store'
import audio from '../launch/audio'

const handleDisbandClick = () => {
    const difficulty = Config.difficultyLevels[Config.difficulty]
    const shipNamesArr = []

    Object.keys(Config.selectedShips).forEach((key) => {
        const ship = Config.ships[key]
        const {name, type, x, y} = ship

        shipNamesArr.push(name)

        new Effects().disband({scale: ship.scale, texture: ship.texture, x, y})

        const salvage =
            type === 'satellite'
                ? difficulty.satelliteResourceDisbandSalvage
                : difficulty.shipResourceDisbandSalvage

        Config.gameStats.resources += salvage
        audio.disband()

        new Effects().resourceAnim({
            x,
            y,
            num: salvage,
            positive: true,
        })
    })

    let shipNames = shipNamesArr[0]
    let html = `The ship <span style="color: #${Config.colorGreen}">${shipNames}</span> has been dismantled`

    if (Object.keys(Config.selectedShips).length > 1) {
        shipNames = shipNamesArr.join(', ')
        html = `The ships <span style="color: #${Config.colorGreen}">${shipNames}</span> have been dismantled`
    }

    _addToEventLog({
        html,
        // coords: {x, y},
    })

    Object.keys(Config.selectedShips).forEach((key) => {
        Config.ships[key].destroy()
    })

    forceAppUpdate()
    saveGame('handleDisbandClick')
}

export default handleDisbandClick
